var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductSuper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6224 6.04102L37.5 12.8369V40.7757L18.6224 33.9798V6.04102Z",
    fill: "#FFB454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6224 6.04102L37.5 12.8369V40.7757L55.6224 33.9798V6.04102Z",
    fill: "#FF8E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0L55.6224 6.04082L37.5 12.8367L18.6224 6.04082L37.5 0Z",
    fill: "#FFDD54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0L55.6224 6.04082L37.5 12.8367V6.79592V0Z",
    fill: "#FFB454"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 39.2637L18.6224 46.0596V73.9984L0.5 67.4743V39.2637Z",
    fill: "#F90024"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 39.2637L18.6224 46.0596V73.9984L37.5 67.9576V39.2637Z",
    fill: "#A50017"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6224 33.2227L37.5 39.2635L18.6224 46.0594L0.5 39.2635L18.6224 33.2227Z",
    fill: "#FF6B6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 39.2637L55.6224 46.0596V73.9984L37.5 67.4743V39.2637Z",
    fill: "#4793FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 39.2637L55.6224 46.0596V73.9984L74.5 67.9576V39.2637Z",
    fill: "#005EDF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6224 33.2227L74.5 39.2635L55.6224 46.0594L37.5 39.2635L55.6224 33.2227Z",
    fill: "#8BB9FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3971_1423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 39,
    r: 16,
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3376 41.784C41.3376 42.3387 41.1936 42.8613 40.9056 43.352C40.6283 43.832 40.2123 44.232 39.6576 44.552C39.1136 44.8613 38.4683 45.0427 37.7216 45.096V46.392H36.6976V45.08C35.631 44.984 34.7723 44.664 34.1216 44.12C33.471 43.5653 33.135 42.8187 33.1136 41.88H35.5136C35.5776 42.648 35.9723 43.112 36.6976 43.272V40.216C35.9296 40.024 35.311 39.832 34.8416 39.64C34.3723 39.448 33.967 39.1387 33.6256 38.712C33.2843 38.2853 33.1136 37.704 33.1136 36.968C33.1136 36.04 33.4443 35.2827 34.1056 34.696C34.7776 34.1093 35.6416 33.7733 36.6976 33.688V32.392H37.7216V33.688C38.7456 33.7733 39.5616 34.0827 40.1696 34.616C40.7883 35.1493 41.135 35.8853 41.2096 36.824H38.7936C38.7616 36.5147 38.6496 36.248 38.4576 36.024C38.2763 35.7893 38.031 35.624 37.7216 35.528V38.552C38.5216 38.7547 39.151 38.952 39.6096 39.144C40.079 39.3253 40.4843 39.6293 40.8256 40.056C41.167 40.472 41.3376 41.048 41.3376 41.784ZM35.4496 36.856C35.4496 37.208 35.5563 37.496 35.7696 37.72C35.983 37.9333 36.2923 38.1093 36.6976 38.248V35.48C36.3136 35.5333 36.0096 35.6773 35.7856 35.912C35.5616 36.1467 35.4496 36.4613 35.4496 36.856ZM37.7216 43.304C38.127 43.2293 38.4416 43.064 38.6656 42.808C38.9003 42.552 39.0176 42.2427 39.0176 41.88C39.0176 41.528 38.9056 41.2453 38.6816 41.032C38.4576 40.8187 38.1376 40.6427 37.7216 40.504V43.304Z",
    fill: "#1BA397"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3971_1423",
    x: 17,
    y: 23,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3971_1423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3971_1423",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSuper);
export default __webpack_public_path__ + "static/media/productSuper.8854be55a4623895175aa2c22fe7070b.svg";
export { ForwardRef as ReactComponent };